[cloak] {
  display: none !important;
}

/* I know .. "no CSS!!!" but hear me out!
 * This font definition must be present until we have a OCCL pre-set (bundle.css) that
 * injects this definition into the page.
 *
 * Currently we do not have this and thus this must stay (for occl).
 * It is taken verbatim from the MFE bundle.css.
 */
:host([theme='occl']) {
  --frame-borderwidth--border-width-m: 2px;
  --color-neutrals--neutral-100: #f3f5f6;

  font-weight: 400;
  font-size: 14px;
  line-height: 1.4;
  font-family: 'On Air', Verdana, Tahoma, sans-serif;
}

:host([theme='tefOne']) {
  --section-container-padding-override: 1rem;
}
